<template>
  <div class="modelForm">
    <a @click="() => (toggleSearchStatus = !toggleSearchStatus)">
      <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
      <p>基础信息</p>
    </a>
    <div v-if="toggleSearchStatus" style="margin-top: 10px">
      <a-form-model :model="form" ref="ruleForm" :rules="rules">
        <a-row :gutter="24" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-col :xl="6">
            <a-form-model-item ref="studentNo" label="学号" prop="studentNo" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="form.studentNo" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="姓名" prop="stuName" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="form.stuName" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="性别" prop="sex" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select @focus="focusChange('sex')" allowClear v-model="form.sex" @change="handelChange" placeholder="请选择性别">
                <a-select-option v-for="(item, index) in sexList" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="证件类型" prop="idType" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="form.idType" allowClear @focus="focusChange('credentials')" placeholder="请选择证件类型">
                <a-select-option v-for="(item, index) in idTypeList" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="证件号码" prop="idNo" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="form.idNo" :min="0" style="width: 100%" />
              <!--              -->
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="出生日期" prop="birthday" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-date-picker @change="onChange" v-model="form.birthday" />
              <!--需要赋值 -->
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="民族" prop="nation" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select @focus="focusChange('nation')" allowClear showSearch v-model="form.nation" placeholder="请选择民族">
                <a-select-option v-for="(item, index) in nationList" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="政治面貌" prop="political" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="form.political" allowClear showSearch @focus="focusChange('political')" placeholder="请选择政治面貌">
                <a-select-option v-for="(item, index) in politicalList" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="户口性质" prop="household" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="form.household" allowClear @focus="focusChange('account_type')" placeholder="请选择户口性质">
                <a-select-option v-for="(item, index) in householdList" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="籍贯" prop="nativeplace" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="form.nativeplace" placeholder="请填写籍贯" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="工作单位" prop="department" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="form.department" placeholder="请填写工作单位" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="工作职位" prop="principalship" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="form.principalship" placeholder="请选择工作职位" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="手机号码" prop="mobile" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-model="form.mobile" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="固定电话" prop="telephone" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-model="form.telephone" style="width: 100%" placeholder="请填写固定电话" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="联系QQ" prop="qq" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-model="form.qq" style="width: 100%" placeholder="请填写QQ" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="6">
            <a-form-model-item label="电子邮箱" prop="email" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="form.email" placeholder="请填写电子邮箱" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="12">
            <!--            :label-col="{ span: 4, offset: 0 }" :wrapper-col="{ span: 20, offset: 0 }"-->
            <a-form-model-item
              label="通讯地址"
              prop="address"
              :labelCol="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapperCol="{ xs: { span: 24 }, sm: { span: 20 } }"
            >
              <a-input v-model="form.address" placeholder="请填写通讯地址" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="12" style="padding-left:6px;">
            <a-form-model-item
              label="毕业院校"
              prop="graduate"
              :labelCol="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapperCol="{ xs: { span: 24 }, sm: { span: 20 } }"
            >
              <a-input v-model="form.graduate" placeholder="请填写工作院校" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <a @click="() => (toggleSearchStatusTwo = !toggleSearchStatusTwo)" style="margin-top:10px">
      <a-icon :type="toggleSearchStatusTwo ? 'up' : 'down'" />
      <p>简历（学历、职历）</p>
    </a>
    <div v-if="toggleSearchStatusTwo" style="margin-top: 10px">
      <a-form-model :form="form">
        <a-row :gutter="24" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div v-for="(item, index) in form.resumeList" :key="index">
            <a-col :xl="6">
              <a-form-model-item
                label="起止年月"
                prop="years"
                :labelCol="{ xs: { span: 24 }, sm: { span: 8 } }"
                :wrapperCol="{ xs: { span: 24 }, sm: { span: 10 } }"
              >
                <a-range-picker @change="(date, dateString) => onChanges(date, dateString, item)" v-model="item.years" style="width: 210px" />
                <!--需要赋值 -->
              </a-form-model-item>
            </a-col>
            <a-col :xl="7">
              <a-form-model-item
                label="在何单位"
                prop="department"
                :labelCol="{ xs: { span: 24 }, sm: { span: 10 } }"
                :wrapperCol="{ xs: { span: 24 }, sm: { span: 14 } }"
              >
                <a-input v-model="item.department" placeholder="请填写任职单位" />
              </a-form-model-item>
            </a-col>
            <a-col :xl="7">
              <a-form-model-item label="任职经历" prop="principalship" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="item.principalship" placeholder="请填写任职经历" />
              </a-form-model-item>
            </a-col>
            <a-col :xl="2">
              <a-button
                @click="delremoveRowTwo(item)"
                v-if="form.resumeList.length > 1"
                style="margin-top: 0.5em;background: #2caf7a;color: #fff;border: 1px solid #2caf7a"
              >
                删除
              </a-button>
            </a-col>
          </div>
          <a-col :xl="2">
            <a-button @click="addToggleSearchStatusTwo()" style="margin-top: 0.5em;background: #2caf7a;color: #fff;border: 1px solid #2caf7a">新增</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <a @click="() => (toggleSearchStatusThree = !toggleSearchStatusThree)" style="margin-top:10px">
      <a-icon :type="toggleSearchStatusThree ? 'up' : 'down'" />
      <p>家庭主要成员</p>
    </a>
    <div v-if="toggleSearchStatusThree" style="margin-top: 10px">
      <a-form :form="form">
        <a-row :gutter="24" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div v-for="(item, index) in form.familyList" :key="index">
            <a-col :xl="5" style="padding-left: 15px">
              <a-form-model-item
                label="与本人关系"
                prop="item.relationship"
                :labelCol="{ xs: { span: 24 }, sm: { span: 10 } }"
                :wrapperCol="{ xs: { span: 24 }, sm: { span: 14 } }"
              >
                <a-input v-model="item.relationship" placeholder="请填写与本人关系" />
              </a-form-model-item>
            </a-col>
            <a-col :xl="4" style="padding-left: 0">
              <a-form-model-item
                label="姓名"
                prop="item.name"
                :labelCol="{ xs: { span: 24 }, sm: { span: 6 } }"
                :wrapperCol="{ xs: { span: 24 }, sm: { span: 18 } }"
              >
                <a-input v-model="item.name" placeholder="请填写家庭成员姓名" />
              </a-form-model-item>
            </a-col>
            <a-col :xl="4" style="padding-left: 0">
              <a-form-model-item
                label="政治面貌"
                prop="item.political"
                :labelCol="{ xs: { span: 24 }, sm: { span: 10 } }"
                :wrapperCol="{ xs: { span: 24 }, sm: { span: 14 } }"
              >
                <a-select v-model="item.political" @focus="focusChange('political')" placeholder="请选择家庭成员政治面貌" allowClear showSearch>
                  <a-select-option v-for="(item1, index1) in familyPoliticalList" :key="index1" :value="item1.value">
                    {{ item1.text }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :xl="4" style="padding-left: 0">
              <a-form-model-item
                label="工作单位"
                prop="item.department"
                :labelCol="{ xs: { span: 24 }, sm: { span: 10 } }"
                :wrapperCol="{ xs: { span: 24 }, sm: { span: 14 } }"
              >
                <a-input v-model="item.department" placeholder="请填写家庭成员工作单位" />
              </a-form-model-item>
            </a-col>
            <a-col :xl="3" style="padding-left: 0">
              <a-form-model-item
                label="职位"
                prop="item.principalship"
                :labelCol="{ xs: { span: 24 }, sm: { span: 8 } }"
                :wrapperCol="{ xs: { span: 24 }, sm: { span: 16 } }"
              >
                <a-input v-model="item.principalship" placeholder="请填写家庭成员职位" />
              </a-form-model-item>
            </a-col>
            <a-col :xl="2">
              <a-button
                @click="delremoveRowThree(item)"
                style="margin-top: 0.5em;background: #2caf7a;color: #fff;border: 1px solid #2caf7a"
                v-if="form.familyList.length > 1"
              >
                删除
              </a-button>
            </a-col>
          </div>
          <a-col :xl="2" style="padding-left: 0">
            <a-button style="margin-top: 0.5em;background: #2caf7a;color: #fff;border: 1px solid #2caf7a" @click="addToggleSearchStatusThree()">新增</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <footer>
      <a-button v-if="isBoolean === true" @click="putEdit" style="margin-top: 0.5em;background: #2caf7a;color: #fff;border: 1px solid #2caf7a">提交1</a-button>
      <a-button v-else @click="submit" style="margin-top: 0.5em;background: #2caf7a;color: #fff;border: 1px solid #2caf7a">提交</a-button>
      <a-button @click="reset" style="margin-top: 0.5em;background: #2caf7a;color: #fff;border: 1px solid #2caf7a">重置</a-button>
    </footer>
  </div>
</template>

<script>
let validatorPhone = (rule, value, callback) => {
  // 如果为空值，就抛出错误
  if (!value) {
    callback(new Error('请填写手机号'));
  } else {
    // 正则判断手机号格式的格式，正则判断失败抛出错误，否则直接callback()
    if (!/^1[2-9]\d{9}$/.test(value)) {
      callback(new Error('手机号格式不正确!'));
    } else {
      callback();
    }
  }
};
export default {
  name: 'StartMOdelForm',
  data() {
    return {
      toggleSearchStatus: true,
      toggleSearchStatusTwo: true,
      toggleSearchStatusThree: true,
      form: {
        studentNo: '', //学号
        stuName: '', //姓名
        idType: '', //证件类型
        sex: '', //性别
        idNo: '', //证件号码
        birthday: '', //出生日期
        nation: '', //民族
        political: '', //政治面貌
        household: '', //户口性质
        nativeplace: '', //籍贯
        department: '', //工作单位
        principalship: '', //工作职位
        mobile: '', //手机号码
        telephone: '', //固定电话
        qq: '', //联系qq
        email: '', //电子邮箱
        address: '', //通讯地址
        graduate: '', //毕业学校
        resumeList: [
          {
            years: [], //起止年月
            ymStart: '', //起始年月
            ymEnd: '', //截止年月
            department: '', //工作单位
            principalship: '', //工作经历职务
            rowNum: undefined,
          },
        ],
        familyList: [
          {
            department: '', //家人工作单位
            name: '', //家人姓名
            political: '', //家人政治面貌
            principalship: '', //家人工作职位
            rowNum: undefined,
            relationship: '', //本人关系
          },
        ],
        region: '',
        date1: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      rules: {
        studentNo: [{ required: true, message: '请输入学号', trigger: 'blur' }],
        stuName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        nation: [{ required: true, message: '请选择民族', trigger: 'change' }],
        political: [{ required: true, message: '请选择政治面貌', trigger: 'change' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        idNo: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
        birthday: [{ required: true, message: '请选择证件', trigger: 'change' }],
        idType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
        mobile: [{ required: true, validator: validatorPhone, trigger: 'change' }],
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
      nationList: [], //民族列表
      sexList: [], //性别列表
      politicalList: [], //政治面貌列表
      familyPoliticalList: [], //家人政治面貌列表
      idTypeList: [], //证件类型列表
      householdList: [], //户口性质列表
      isBoolean: false,
    };
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.form.studentNo = userInfo.studentNo;
    this.form.stuName = userInfo.name;
    this.form.idNo = userInfo.idNo;
    this.form.mobile = userInfo.phone;
    if (userInfo.sex === '1') {
      this.form.sex = '男';
    } else if (userInfo.sex === '2') {
      this.form.sex = '女';
    }
    this.GetQueryBuId();
  },
  methods: {
    GetQueryBuId() {
      this.axios
        .get(`/stu/stuEnrolment/getRxdjxx`, {
          params: {
            studentId: JSON.parse(localStorage.getItem('userInfo')).id,
            eduCode: JSON.parse(localStorage.getItem('userInfo')).eduCode,
          },
        })
        .then(res => {
          console.log(res);
          if (res.code === 200) {
            // this.form = {
            //   studentNo:res.result.studentNo,//学号
            //   stuName: res.result.stuName,//姓名
            //   // idType:res.result.idType?'身份证':'护照':'军官证':'士官证':'港澳台通行证',//证件类型
            //   sex:res.result.sex?'女':'男',//性别
            //   idNo:res.result.createBy,//证件号码
            //   birthday:res.result.birthday,//出生日期
            //   nation:res.result.nation,//民族
            //   political:res.result.political,//政治面貌
            //   household:res.result.household,//户口性质
            //   nativeplace:res.result.nativeplace,//籍贯
            //   department:res.result.department,//工作单位
            //   principalship:res.result.principalship,//工作职位
            //   mobile:res.result.mobile,//手机号码
            //   telephone:res.result.telephone,//固定电话
            //   qq:res.result.qq,//联系qq
            //   email:res.result.email,//电子邮箱
            //   address:res.result.address,//通讯地址
            //   graduate:res.result.graduate,//毕业学校
            //   resumeList:res.result.resumeList,
            //   familyList:res.result.familyList,
            //   region: '',
            //   date1: '',
            //   delivery: false,
            //   type: [],
            //   resource: '',
            //   desc: '',
            // }

            if (res.result != '未找到对应数据') {
              this.form = res.result;
              if (res.result.resumeList != []) {
                this.form.resumeList = res.result.resumeList;
                console.log(this.form.resumeList);
                this.form.resumeList.forEach(item => {
                  item.years = [];
                  item.years.push(item.ymStart, item.ymEnd);
                });
              } else {
                this.form.resumeList = [
                  {
                    years: [], //起止年月
                    ymStart: '', //起始年月
                    ymEnd: '', //截止年月
                    department: '', //工作单位
                    principalship: '', //工作经历职务
                    rowNum: undefined,
                  },
                ];
              }

              if (res.result.familyList != []) {
                this.form.familyList = res.result.familyList;
              } else {
                this.form.familyList = [
                  {
                    department: '', //家人工作单位
                    name: '', //家人姓名
                    political: '', //家人政治面貌
                    principalship: '', //家人工作职位
                    rowNum: undefined,
                    relationship: '', //本人关系
                  },
                ];
              }
              if (this.form.sex === '1') {
                this.form.sex = '男';
              } else if (this.form.sex == '2') {
                this.form.sex = '女';
              }
              if (res.result.idType == 1) {
                this.form.idType = '身份证';
              } else if (res.result.idType == 2) {
                this.form.idType = '护照';
              } else if (res.result.idType == 3) {
                this.form.idType = '军官证';
              } else if (res.result.idType == 4) {
                this.form.idType = '士官证';
              } else if (res.result.idType == 5) {
                this.form.idType = '港澳台通行证';
              }
              this.isBoolean = true;
            } else {
              this.form.resumeList = [
                {
                  years: [], //起止年月
                  ymStart: '', //起始年月
                  ymEnd: '', //截止年月
                  department: '', //工作单位
                  principalship: '', //工作经历职务
                  rowNum: undefined,
                },
              ];
              this.form.familyList = [
                {
                  department: '', //家人工作单位
                  name: '', //家人姓名
                  political: '', //家人政治面貌
                  principalship: '', //家人工作职位
                  rowNum: undefined,
                  relationship: '', //本人关系
                },
              ];
              this.isBoolean = false;
            }
          } else {
            this.isBoolean = false;
          }
        });
    },
    putEdit() {
      let resumeList = [];
      let familyList = [];
      if (this.form.resumeList.length <= 1) {
        this.form.resumeList.forEach((item, index) => {
          if (item.department == '' || item.principalship == '' || item.ymStart == '' || item.ymEnd == '') {
            resumeList = [];
          } else {
            resumeList.push({
              department: item.department,
              principalship: item.principalship,
              ymStart: item.ymStart,
              rowNum: index + 1,
              ymEnd: item.ymEnd,
            });
          }
        });
      } else if (this.form.resumeList.length > 1) {
        for (let i = 0; i < this.form.resumeList.length > 0; i++) {
          let item = this.form.resumeList[i];
          if (item.department == '' || item.principalship == '' || item.ymStart == '' || item.ymEnd == '') {
            i = this.form.resumeList.length + 1;
            return this.$message.warning('请填写本人简历');
          } else {
            resumeList.push({
              department: item.department,
              principalship: item.principalship,
              ymStart: item.ymStart,
              rowNum: i + 1,
              ymEnd: item.ymEnd,
            });
          }
        }
      }
      if (this.form.familyList.length <= 1) {
        this.form.familyList.forEach((item, index) => {
          if (item.department == '' || item.name == '' || item.political == '' || item.principalship == '' || item.relationship == '') {
            familyList = [];
            // return this.$message.warning('请填写家人主要成员列表');
          } else {
            familyList.push({
              department: item.department, //家人工作单位
              name: item.name, //家人姓名
              political: item.political, //家人政治面貌
              principalship: item.principalship, //家人工作职位
              rowNum: index + 1,
              relationship: item.relationship, //本人关系
            });
          }
        });
      } else if (this.form.familyList.length > 1) {
        for (let i = 0; i < this.form.familyList.length; i++) {
          let item = this.form.familyList[i];
          if (item.department == '' || item.name == '' || item.political == '' || item.principalship == '' || item.relationship == '') {
            // familyList = [];
            i = this.form.familyList.length + 1;
            return this.$message.warning('请填写家人主要成员列表');
          } else {
            familyList.push({
              department: item.department, //家人工作单位
              name: item.name, //家人姓名
              political: item.political, //家人政治面貌
              principalship: item.principalship, //家人工作职位
              rowNum: i + 1,
              relationship: item.relationship, //本人关系
            });
          }
        }
      }
      this.axios.put(`/stu/stuEnrolment/edit`, this.form).then(res => {
        if (res.code === 200) {
          this.$message.success(res.result);
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    getNation(code) {
      this.axios.get(`/sys/dict/getDictItems/${code}`).then(res => {
        if (code == 'nation') {
          this.nationList = res.result;
        } else if (code == 'sex') {
          this.sexList = res.result;
        } else if (code == 'political') {
          this.politicalList = res.result;
          this.familyPoliticalList = res.result;
        } else if (code == 'account_type') {
          this.householdList = res.result;
        } else if (code == 'credentials') {
          this.idTypeList = res.result;
        }
      });
    },
    //添加工作经历或家人列表，每一列每一个没有填数据时，rowNum为undefined
    delremoveRowTwo(item) {
      let index = this.form.resumeList.indexOf(item);
      if (index !== -1) {
        this.form.resumeList.splice(index, 1);
        if (this.form.resumeList.length >= 1) {
          this.form.resumeList[0].rowNum = 1;
        }
      }
      console.log(this.form.resumeList);
    },
    addToggleSearchStatusTwo() {
      console.log('新增简历行2');
      this.form.resumeList.push({
        years: [], //起止年月
        ymStart: '', //起始年月
        ymEnd: '', //截止年月
        department: '', //工作单位
        principalship: '', //工作经历职务
        rowNum: this.form.resumeList.length + 1,
      });

      console.log(this.form.resumeList);
    },
    delremoveRowThree(item) {
      //删除时  rowNum有问题
      let index = this.form.familyList.indexOf(item);
      if (index !== -1) {
        this.form.familyList.splice(index, 1);
        if (this.form.familyList.length >= 1) {
          this.form.familyList[0].rowNum = 1;
        }
      }
      console.log(this.form.familyList);
    },
    addToggleSearchStatusThree() {
      console.log('新增简历行3');
      this.form.familyList.push({
        department: '', //家人工作单位
        name: '', //家人姓名
        political: '', //家人政治面貌
        principalship: '', //家人工作职位
        rowNum: this.form.familyList.length + 1,
        relationship: '', //本人关系
      });
      console.log(this.form.familyList);
    },
    onChange(date, dateString) {
      console.log(dateString);
      this.form.birthday = dateString;
    },
    onChanges(date, dateString, item) {
      item.ymStart = dateString[0].slice(0, 7);
      item.ymEnd = dateString[1].slice(0, 7);
    },
    focusChange(code) {
      this.getNation(code);
    },
    handelChange(val) {
      this.form.sex = val;
    },
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let resumeList = [];
          let familyList = [];
          if (this.form.resumeList.length <= 1) {
            this.form.resumeList.forEach((item, index) => {
              if (item.department == '' || item.principalship == '' || item.ymStart == '' || item.ymEnd == '') {
                resumeList = [];
                // return this.$message.warning('请填写本人简历')
              } else {
                resumeList.push({
                  department: item.department,
                  principalship: item.principalship,
                  ymStart: item.ymStart,
                  rowNum: index + 1,
                  ymEnd: item.ymEnd,
                });
              }
            });
          } else if (this.form.resumeList.length > 1) {
            for (let i = 0; i < this.form.resumeList.length > 0; i++) {
              let item = this.form.resumeList[i];
              if (item.department == '' || item.principalship == '' || item.ymStart == '' || item.ymEnd == '') {
                // resumeList = []
                i = this.form.resumeList.length + 1;
                return this.$message.warning('请填写本人简历');
                //
              } else {
                resumeList.push({
                  department: item.department,
                  principalship: item.principalship,
                  ymStart: item.ymStart,
                  rowNum: i + 1,
                  ymEnd: item.ymEnd,
                });
              }
            }
          }
          if (this.form.familyList.length <= 1) {
            this.form.familyList.forEach((item, index) => {
              if (item.department == '' || item.name == '' || item.political == '' || item.principalship == '' || item.relationship == '') {
                // familyList = []
                // return this.$message.warning('请填写家人主要成员列表');
              } else {
                familyList.push({
                  department: item.department, //家人工作单位
                  name: item.name, //家人姓名
                  political: item.political, //家人政治面貌
                  principalship: item.principalship, //家人工作职位
                  rowNum: index + 1,
                  relationship: item.relationship, //本人关系
                });
              }
            });
          } else if (this.form.familyList.length > 1) {
            for (let i = 0; i < this.form.familyList.length; i++) {
              let item = this.form.familyList[i];
              if (item.department == '' || item.name == '' || item.political == '' || item.principalship == '' || item.relationship == '') {
                // familyList = [];
                i = this.form.familyList.length + 1;
                return this.$message.warning('请填写家人主要成员列表');
              } else {
                familyList.push({
                  department: item.department, //家人工作单位
                  name: item.name, //家人姓名
                  political: item.political, //家人政治面貌
                  principalship: item.principalship, //家人工作职位
                  rowNum: i + 1,
                  relationship: item.relationship, //本人关系
                });
              }
            }
          }
          // return
          let params = {
            studentId: JSON.parse(localStorage.getItem('userInfo')).id, //学生id
            eduCode: JSON.parse(localStorage.getItem('userInfo')).eduCode, //学校id
            address: this.form.address, //通讯地址
            birthday: this.form.birthday, //出生日期
            department: this.form.department, //工作单位
            email: this.form.email, //电子邮箱
            graduate: this.form.graduate, //毕业院校
            household: this.form.household, //户口性质
            idNo: this.form.idNo, //身份证号码
            idType: this.form.idType, //证件类型
            mobile: this.form.mobile, //手机号码
            nation: this.form.nation, //民族
            nativeplace: this.form.nativeplace, //籍贯
            political: this.form.political, //政治面貌
            principalship: this.form.principalship, //工作职务
            qq: this.form.qq, //qq
            remark: '', //备注
            sex: this.form.sex, //性别
            stuName: this.form.stuName, //学生姓名
            studentNo: this.form.studentNo, //学生学号
            telephone: this.form.telephone, //学生固定电话
            resumeList: resumeList,
            familyList: familyList,
          };

          console.log(params);
          // return
          this.axios.post(`/stu/stuEnrolment/add`, params).then(res => {
            // console.log(res)
            if (res.code === 200) {
              this.$message.success(res.message);
            } else {
              this.$message.warning(res.message);
            }
          });
        } else {
          this.$message.warning('请完整填写信息');
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset() {
      this.$refs.ruleForm.resetFields();
      this.form.resumeList = [
        {
          years: [], //起止年月
          ymStart: '', //起始年月
          ymEnd: '', //截止年月
          department: undefined, //工作单位
          principalship: undefined, //工作经历职务
          rowNum: 1,
        },
      ];
      this.form.familyList = [
        {
          department: '', //家人工作单位
          name: '', //家人姓名
          political: '', //家人政治面貌
          principalship: '', //家人工作职位
          rowNum: 1,
          relationship: '', //本人关系
        },
      ];
      console.log('重置');
    },
  },
};
</script>

<style scoped>
.modelForm {
  margin-top: 20px;
}
.modelForm > a:hover {
  color: #ffffff;
}
.modelForm > a {
  height: 30px;
  display: flex;
  align-items: center;
  background: #2caf7a /*主色调颜色*/;
  color: #fff;
  padding-left: 10px;
}
.modelForm > a p {
  margin-left: 10px;
}
footer {
  margin-top: 10px;
  text-align: center;
}
.modelForm .ant-form .ant-col-xl-6 {
  /*border: 1px solid red;*/
  height: 70px !important;
}
/deep/ .ant-form .ant-input-number-input {
  padding: 0 5px;
}
/deep/ .ant-form .ant-input-number-handler-wrap {
  display: none;
}
</style>
<style></style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/StartModelForm.vue